// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.structured-list {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.structured-list .add-step-btn {
  color: #AA2F22;
  font-size: 14px;
  font-weight: 400;
}
.structured-list .add-step-btn:hover {
  color: #AA2F22;
}
.structured-list-item {
  border: 1px solid #E9EAEB;
  padding: 1.5rem;
  border-radius: 0.5rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./wp_components/core/StructuredList/index.less"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;ACDJ;ADFA;EAMQ,cAAA;EACA,eAAA;EACA,gBAAA;ACDR;ADGQ;EACI,cAAA;ACDZ;ADOA;EACI,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;ACLJ;AACA,oCAAoC","sourcesContent":["@import \"../../../less/variables.less\";\n\n.structured-list {\n    display: flex;\n    flex-direction: column;\n    gap: 1.2rem;\n\n    .add-step-btn {\n        color: @primary-700;\n        font-size: 14px;\n        font-weight: @font-weight-normal;\n\n        &:hover {\n            color: @primary-700;\n        }\n    }\n    \n}\n\n.structured-list-item {\n    border: 1px solid @separator-color;\n    padding: 1.5rem;\n    border-radius: 0.5rem;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n",".structured-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n}\n.structured-list .add-step-btn {\n  color: #AA2F22;\n  font-size: 14px;\n  font-weight: 400;\n}\n.structured-list .add-step-btn:hover {\n  color: #AA2F22;\n}\n.structured-list-item {\n  border: 1px solid #E9EAEB;\n  padding: 1.5rem;\n  border-radius: 0.5rem;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
